import React, { useContext } from 'react';
import cn from 'classnames';
import { CountryOfBusinessContext } from '@dataroom/country-of-business/CountryOfBusinessContext';
import { IDataroomListItem } from '../../../domain/vo/DataroomListItem';
import CountryRestrictionTooltip from './CountryRestrictionTooltip';
import styles from '../datarooms.module.scss';

interface IProps {
  cellProps: {
    row: IDataroomListItem,
  },
}

const NameCellWithCountryCheck = ({ cellProps }: IProps) => {
  const context = useContext(CountryOfBusinessContext);
  const countryId = context?.countryId;
  const dataroom = cellProps.row;
  const restrictedCountryIds = dataroom.restrictedCountryIds ?? [];
  const isRestricted = countryId != null && restrictedCountryIds.includes(countryId);

  return (
    <>
      <span className={ cn({ [styles.columnDisable]: isRestricted }) }>
        { dataroom.displayName }
      </span>
      <CountryRestrictionTooltip restrictedCountryIds={ restrictedCountryIds } />
    </>
  );
};

export default NameCellWithCountryCheck;
